import React from 'react'
import { ImportProductActionMappingFields } from '@ztechapps/common.contract'

export const actionFieldsData = [
  {
    fieldName: ImportProductActionMappingFields.update_Quantity,
    value: <div>Use this to adjust the quantity on hand of the product.</div>,
  },

  {
    fieldName: ImportProductActionMappingFields.create_SubAssembly,
    value: (
      <div>
        Use this to create a new product. The parent product will be updated to include this on bill of materials.
        Sample (:Base, :Punch)
      </div>
    ),
  },

  {
    fieldName: ImportProductActionMappingFields.include_SubAssembly,
    value: (
      <div>
        Use this to add existing product code to the bill of materials of hte current product. Sample (uuDPullBolt,
        Spring Nibbler)
      </div>
    ),
  },
]
